import styled from 'styled-components';

export const MenuList = styled.menu`
  ${({ theme }) => `
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    border-radius: 8px;
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    overflow: hidden;
  `};
`;

export const ListItem = styled.li`
  ${({ theme }) => `
    display: flex;
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};

    &:last-of-type {
      border-bottom: none;
    }
  `};
`;
